import { FieldResponse, FormResponse } from "types";

export const getFormResponseField = (
    formResponse: FormResponse | undefined,
    label: string,
): FieldResponse | undefined => formResponse?.fields?.find((field) => field.label === label);
